import SchemaOrg from '@/components/base/SchemaOrg';
import Hero from './components/Hero';
import FeaturedComics from './components/FeaturedComics';
import CategorySection from './components/CategorySection';
import LatestUpdates from './components/LatestUpdates';
import WhyChooseUs from './components/WhyChooseUs';
import FAQ from './components/FAQ';

export default function Home() {
  return (
    <>
      <SchemaOrg type="WebSite" />
      <SchemaOrg type="Organization" />
      <SchemaOrg
        type="WebPage"
        data={{
          name: '韩漫之家 - 韩国漫画在线观看平台',
          description: '韩漫之家是韩国漫画在线观看平台，拥有海量正版韩漫资源，支持下拉式阅读，画质高清，更新快，为您提供安心阅读环境。',
        }}
      />
      <main>
        <Hero />
        <FeaturedComics />
        <CategorySection />
        <LatestUpdates />
        <WhyChooseUs />
        <FAQ />
      </main>
    </>
  );
}